import { memo, useMemo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Task } from "@common/types/task";
import { useWorkspaceCloses } from "@api/close.api";
import { DateRangeDisplay } from "@components/settings/OrganizationCloseTemplates/DateRangeDisplay";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { NestedTaskRow } from "../../types";

export const ServicePeriodCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        NestedTaskRow,
        Task["closeId"] | null
    >) => {
        const task = row.original as Task;
        const { data: closes = [] } = useWorkspaceCloses();

        const close = useMemo(
            () => closes.find((c) => c.id === task.closeId),
            [closes, task.closeId],
        );

        if (row.original.isGroup || row.original.isNewPlaceholder || !close) {
            return null;
        }

        if (!close.startDate && !close.endDate) {
            return null;
        }

        return (
            <ViewTableCell>
                <DateRangeDisplay
                    startDate={close.startDate}
                    endDate={close.endDate}
                />
            </ViewTableCell>
        );
    },
);
ServicePeriodCell.displayName = "ServicePeriodCell";
